module.exports = __webpack_public_path__ + "images/avatar1.svg";